import { useContext } from 'react';

import { BreakpointContext } from './';
import type { Breakpoint } from './types';

export const useBreakpoint = () => {
  const breakpointContext = useContext(BreakpointContext);
  if (breakpointContext === null) {
    throw new Error('useBreakpoint must be used within BreakpointProvider');
  }

  return breakpointContext?.breakpoint;
};

export const useValidateBreakpoint = (breakpoint: Breakpoint) => {
  const currentBreakpoint = useBreakpoint();

  return currentBreakpoint === breakpoint;
};
